import { Link } from "react-router-dom";
import { dateHelpers } from "../app/helpers";
import { useSessionTenant } from "../features/tenant/tenant.hooks";
import { TenantStatus } from "../features/tenant/tenant.types";

export default function BillingLapsedAlert() {
    const { sessionTenant } = useSessionTenant();
    const show = sessionTenant?.state === TenantStatus.Billing_Lapsed;
    const cutoffDate = sessionTenant?.stateEventDate
        ? dateHelpers.formatDate(sessionTenant.stateEventDate, "Do MMMM YYYY")
        : "the due date";

    if (!show) return null;

    return (
        <div
            className="alert alert-danger rounded-0 mb-0 py-2 px-3 d-flex align-items-center justify-content-center gap-2"
            role="alert"
            style={{ position: "sticky", top: 56, zIndex: 1000 }}
        >
            <span>
                {`You have overdue bills. Please settle the bill before, ${cutoffDate} to avoid account suspension. For more info,`}{" "}
                <Link className="alert-link fw-semibold" to="/admin/general/billing">
                    Go to billing
                </Link>
            </span>
        </div>
    );
}
